<app-loading></app-loading>
<app-font-loader></app-font-loader>

<app-top-menu></app-top-menu>

<app-side-menu></app-side-menu>

<div class="main" [class.has-menu]="menuService.hasMenuItems">
  <router-outlet></router-outlet>
</div>
